import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import IncomeStatementEdit from './IncomeStatementEdit';
import moment from 'moment';
import {  Tooltip } from 'antd';
import ProductEdit from './ProductEdit';
import { useContext, useEffect, useRef, useState } from 'react';
import { SocketContext } from '../../../App';

export default function Accountant(props: any) {
    const ref = useRef<any>(undefined);
    const apiId="incomeStatement"
    /**打开商品窗口 */
    const [modalProductOpen, setModalProductOpen] = useState<boolean>(false);
    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;
    /**传递商品窗口的数据 */
    const [productData, setProductData] = useState<any>()
    //表头
    const columnsHead = [
        // {
        //     title: '会计期',
        //     dataIndex: "accountant",
        //     render: (text: any) => (text ? text.accountantName : "")
        // },
        {
            title: '仓库',
            dataIndex: 'entrepot',
            render: (text: any) => (text ? text.entrepotName : "")

        },

        {
            title: "日期",
            dataIndex: "sysDate",

            render: (val: any, record: any) =>
                <span>
                    {moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                </span>,

        },
    ];
    useEffect(() => {
        // getEntrepot(contextData?.currentEntrepotId)
        if (contextData?.currentEntrepotId && contextData?.refresh) {

            onRefresh({ entrepotId: contextData?.currentEntrepotId })
        }
    })
    const onRefresh = (item: any) => {
        const { entrepotId } = item
        const currentData: initDataType = {
            apiId,
            sendPageData: { entrepotId }
        }
        ref.current.initData(currentData);
        setContextData({ ...contextData, refresh: false, })
       
    }
    const columns = columnsheadId
        .concat(columnsHead as []);
    const expandableColumnsHead: Array<any> = [
        {
            title: "id",
            dataIndex: "id",
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 10 ? text.substring(0, 10) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: "商品名称",
            dataIndex: "product",
            render: (text: any) => (text ? text.productName : "")
        },
        {
            title: "商品单位",
            dataIndex: "product",
            render: (text: any) => (text ? text.productUnit.productUnitName : "")
        },
        {
            title: "规格",
            dataIndex: "productSpecifications"
        },
        {
            title: "数量",
            dataIndex: "bNum"
        },
        {
            title: "备注",
            dataIndex: "memo"
        },
  
    ]
    /**修改商品数据 */
    const onChangeProduct = (item: any, apiId: string, title: any) => {
        setProductData({ id: item.id, apiId, title })
        setModalProductOpen(true)

    }
    /**关闭商品窗口并刷新数据 */
    const onCloseProductOpen = (status: Boolean) => {
        setModalProductOpen(false)
        if (status === true) {
            ref.current.initData();
        }
    }
    /** 子表头 */
    const expandableColumns = expandableColumnsHead;
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '溢损单',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: IncomeStatementEdit,
        sendPageData: { entrepotId: contextData?.currentEntrepotId },
        mountDataOptions:{
            userMount: {
                isEmployees: true,
                isDept:true,
                isUserAreas:true
            }
           },
        //子表格
        isExpandable: true,
        expandableColumns,
        expandableDataName: 'incomeStatementProducts',
    };
    /** 子表头内容 */

    return (
        <>
            <WebUniversalNewEx ref={ref} props={extendProps}></WebUniversalNewEx>

            {modalProductOpen ? (<ProductEdit data={productData} closeModal={onCloseProductOpen}
            />)
                : null}
        </>

    )
}
